<template>
  <div class="components">
    <!-- <el-collapse v-model="componentKeys"> -->
    <!-- <a-collapse :defaultActiveKey="componentKeys" :bordered="false" expandIconPosition="right"> -->
    <!-- <a-collapse-panel v-for="group in data" :key="group.key" :header="group.name"> -->
    <!-- <el-collapse-item v-for="(group,index) in data" :key="index" :title="group.name" :name="index"> -->
    <div>
      <div v-for="(group, index) in data" :key="index" class="module_box">
        <div class="group_title">{{ group.name }}</div>
        <div class="module-list">
          <div
            v-for="(item, index) in group.data"
            :key="index"
            class="module-item"
            @click="handleClickItem(item.type,item.disable)"
          >
            <!-- <object style="color: #f00;width: 30px;height: 30px;" :data="item.icon" type="image/svg+xml"></object> -->
            <img class="module-icon" :src="item.icon" alt="" srcset="" />
            <span class="module-title">{{ item.name }}</span>
            <!-- <img src="@/assets/page/icon/banner.png" alt="" /> -->
          </div>
        </div>
      </div>
    </div>

    <!-- </el-collapse-item> -->
    <!-- </el-collapse> -->
  </div>
</template>

<script>
// import { filterModules } from '@/core/app'
import * as Icon from "@/assets/icons/page/components";

const data = [
  {
    name: "基础组件",
    key: "media",
    data: [
      {
        name: "图片轮播",
        type: "banner",
        icon: require("@/assets/page/icon/banner.png"),
      },
      {
        name: "单图组",
        type: "image",
        icon: require("@/assets/page/icon/image.png"),
      },
      {
        name: "魔方",
        type: "window",
        icon: require("@/assets/page/icon/window.png"),
      },
      {
        name: "热区",
        type: "hotZone",
        icon: require("@/assets/page/icon/hotZone.png"),
      },

      {
        name: "视频",
        type: "video",
        icon: require("@/assets/page/icon/video.png"),
      },
      {
        name: "搜索框",
        type: "search",
        icon: require("@/assets/page/icon/search.png"),
      },
      {
        name: "导航组",
        type: "navBar",
        icon: require("@/assets/page/icon/navBar.png"),
      },
	  {
	    name: "门店分类",
	    type: "life",
	    icon: require("@/assets/page/icon/life.png"),
	  },
	  {
	    name: "门店列表",
	    type: "lifelist",
	    icon: require("@/assets/page/icon/menlist.png"),
	  },
	  {
	    name: "标签页",
	    type: "tabgoods",
	    icon: require("@/assets/page/icon/tab.png"),
	  },
      {
        name: "商品组",
        type: "goods",
        icon: require("@/assets/page/icon/goods.png"),
      },
	  {
	    name: "积分商品",
	    type: "pointergoods",
	    icon: require("@/assets/page/icon/jigong.png"),
	  },
      {
        name: "标题栏",
        type: "title",
        icon: require("@/assets/page/icon/title.png"),
      },
	  {
	    name: "门店切换",
	    type: "stores",
	    icon: require("@/assets/page/icon/storechange.png"),
	  },
	  {
	    name: "富文本",
	    type: "richText",
	    icon: require("@/assets/page/icon/richText.png"),
	  },
	  {
	    name: "辅助空白",
	    type: "blank",
	    icon: require("@/assets/page/icon/blank.png"),
	  },
    ],
  },
  {
    name: "营销组件",
    key: "store",
    data: [
		{
		  name: "礼券",
		  type: "coupon",
		  icon: require("@/assets/page/icon/coupon.png"),
		  moduleKey: "market-coupon",
		},
		{
		  name: "限时秒杀",
		  type: "seckill",
		  icon: require("@/assets/page/icon/seckill.png"),
		  moduleKey: "market-seckill",
		},
		{
		  name: "超值单品",
		  type: "super",
		  icon: require("@/assets/page/icon/super.png"),
		  moduleKey: "market-super"
		},
		{
		  name: "付费券包",
		  type: "couponpack",
		  icon: require("@/assets/page/icon/paidpackage.png"),
		  moduleKey: "market-couponpack"
		},
		// {
		//   name: "竞拍",
		//   type: "auction",
		//   icon: require("@/assets/page/icon/auction.png"),
		//   moduleKey: "market-auction",
		//   disable:true
		// },
		{
		  name: "拼团",
		  type: "groupbuying",
		  icon: require("@/assets/page/icon/groupbuying.png"),
		  moduleKey: "market-groupbuying",
		  disable:true
		},
		{
		  name: "小程序直播",
		  type: "live",
		  icon: require("@/assets/page/icon/miniprogram.png"),
		  moduleKey: "market-live"
		},
		{
		  name: "商品预售",
		  type: "pregood",
		  icon: require("@/assets/page/icon/pregood.png"),
		  moduleKey: "market-pregood",
		  disable:true
		},
		// {
		//   name: "付费会员",
		//   type: "paidmember",
		//   icon: require("@/assets/page/icon/paidmember.png"),
		//   moduleKey: "market-paidmember",
		//   disable:true
		// },
		{
		  name: "签到",
		  type: "checkin",
		  icon: require("@/assets/page/icon/checkin.png"),
		  moduleKey: "market-checkin",
		  disable:true
		},
		// {
		//   name: "任务中心",
		//   type: "missioncenter",
		//   icon: require("@/assets/page/icon/missioncenter.png"),
		//   moduleKey: "market-missioncenter",
		//   disable:true
		// },
		// {
		//   name: "群聊中心",
		//   type: "chatcenter",
		//   icon: require("@/assets/page/icon/chatcenter.png"),
		//   moduleKey: "market-chatcenter",
		//   disable:true
		// }
    ],
  },
  {
    name: "功能组件",
    key: "other",
    data: [
		{
		  name: "在线客服",
		  type: "service",
		  icon: require("@/assets/page/icon/service.png"),
		},
		{
		  name: "头条",
		  type: "special",
		  icon: require("@/assets/page/icon/special.png"),
		},
		// {
		//   name: "百问百答",
		//   type: "article",
		//   icon: require("@/assets/page/icon/article.png"),
		// },
		{
		  name: "好物笔记",
		  type: "article",
		  icon: require("@/assets/page/icon/article.png"),
		},
		{
		  name: "消息通知",
		  type: "notice",
		  icon: require("@/assets/page/icon/notice.png"),
		},
      
      {
        name: "辅助线",
        type: "guide",
        icon: require("@/assets/page/icon/guide.png"),
      },
      {
        name: "备案号",
        type: "ICPLicense",
        icon: require("@/assets/page/icon/ICPLicense.png"),
      },
      {
        name: "关注公众号",
        type: "officialAccount",
        icon: require("@/assets/page/icon/officialAccount.png"),
      },
    ],
  },
];
import { eltips } from "@/util/util.js";
export default {
	
  data() {
    return {
      // componentKeys: [0, 1, 2],
      Icon,
      data,
    };
  },
  computed: {
    // componentKeys() {
    //   const { data } = this;
    //   return data.map((item) => item.key);
    // },
  },
  methods: {
    handleClickItem(type,status) {
		if(status){
			eltips('组件开发中', "error"); 
			return false
		}
      this.$emit("handleClickItem", type);
    },
  },
};
</script>
<style lang="less" scoped>
object {
  /* 直接在CSS中设置 */
  --color: red; /* 这里定义一个CSS变量 */
}
::-webkit-scrollbar {
  width: 0;
  height: 0;
}
::v-deep .el-collapse {
  border-top: 0 !important;
  border-bottom: 0 !important;
}
::v-deep .el-collapse-item__header {
  padding-left: 32px;
  padding-right: 10px;
  font-weight: bold;
  position: relative;
}
::v-deep .el-collapse-item__arrow {
  position: absolute;
  left: 12px;
}
// 组件库
.components {
  width: 320px;
  // background: #f8f9fa;
  height: 100%;
  background: #ffffff;
  overflow-y: auto;
  border-radius: 6px;

  /deep/.ant-collapse-header {
    padding: 14px 16px;
    font-size: 14px;
    font-weight: 700;
    color: #595961;
  }

  /deep/.ant-collapse-content-box {
    padding-top: 0 !important;
  }

  /deep/.ant-collapse > .ant-collapse-item {
    border-bottom: none;
  }

  .module-list {
    display: flex;
    flex-wrap: wrap;
    margin-left: 10px;
  }

  .module-item {
    width: 77px;
    height: 77px;
    padding: 20px 0;
    text-align: center;
    font-size: 13px;
    color: #595961;
    line-height: 20px;
    position: relative;
    user-select: none;
    cursor: pointer;
    display: flex;
    align-items: center;
    justify-content: center;
    flex-direction: column;
    background: rgba(0, 106, 255, 0.03);
    margin: 10px;
    border-radius: 5px;
    border: 1px solid rgba(0, 106, 255, 0) ;
	font-weight: bold;
    &:hover {
      // background: #f7f7f7;
      border-radius: 4px;
      color: #006aff;
      border: 1px solid #006aff !important;
      font-weight: bold;
    }
    .module-icon {
      position: relative;
      font-weight: 300;
      // left: -400px;
      // filter: drop-shadow( #006AFF 400px 0);
      // filter: invert(100%) sepia(96%) saturate(3726%) hue-rotate(336deg) brightness(99%) contrast(102%); /* 换成你想要的颜色 */
    }
    // .module-icon{
    // 	left: -500px;
    // 	filter: drop-shadow(#2067ad 500px 0) !important;
    // }
    .module-icon {
      display: block;
      width: 25px;
      height: 25px;
      line-height: 30px;
      margin: 0 auto 5px auto;
      // color: #9797a1;
      // opacity: 0.5;
    }
  }
}
.group_title {
  font-size: 14px;
  font-weight: 600;
  padding: 0px 15px 5px;
}
.module_box:nth-child(n+2) .group_title{
    margin-top: -2px;
    // background: red;
  }
.module_box:nth-child(1) .group_title{
    margin-top: 15px;
    // background: rgb(4, 0, 255);
  }
// 修改不要下划线
/deep/.el-collapse-item__wrap {
  border-bottom: none;
}
/deep/.el-collapse-item__header {
  border-bottom: none;
}
</style>
